import axios from 'axios'
import utils from '../Utils'


let myWallet = undefined

async function getWallet() {
  if (!myWallet) {
    let result = await utils.iaxios({
      method: 'get',
      url: utils.urls.myWalletUrl,

    }, true)
      // let result = await axios.get(utils.urls.roomStatusURL + `?roomId=${this.state.room_id}`, {
      //   headers: {
      //     'x-access-token': Matrix.getToken()
      //   }
      // })
      .catch((e) => {
        console.log(e.response)
        let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
        // this.SnackBar.openSnackbar(message)
      });
    // this.setState({ loading: false })

    if (!result) return
    console.log(result, '###############')

    let { success, wallet } = result.data;
    myWallet = wallet
  }
  return myWallet
}

export default {
  getWallet
}